import React, { useState } from 'lib/react';

import { useDispatch, useSelector } from 'lib/redux';
import { useTranslation } from 'lib/translation';
import {
  EVGrid, EVAlert, EVTypography, EVCheckCircleOutlineIcon,
} from 'lib/components';

import { updateSRSBranchEmployeeInfo, validateSRSBranchEmployee, updateSRSBranchEmployeeErrorInfo } from 'features/order/Order.actions';
import { checkIfMessagesAreUpdated, updateMessages } from 'utils/validation.util';
import ValidationMessageBanner from 'commonComponents/validationMessageBanner';
import SRSBranchEmployeeForm from 'features/order/components/SRS/SRSBranchEmployeeForm/SRSBranchEmployeeForm.component';
import SRSBranchEmployeeStyles from './SRSBranchEmployeeStyles';

function SRSBranchEmployeeComponent() {
  const classes = SRSBranchEmployeeStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [elementRefInfo, setElementRefInfo] = useState();
  const updateElementRefInfo = (componentRefInfo) => {
    setElementRefInfo((prevState = {}) => ({ ...prevState, ...componentRefInfo }));
  };
  const {
    srsOrgNodeName,
    srsValidation,
    srsBranchEmployee: { srsBranchEmployeeInfo, srsBranchEmployeeInfoErrorsForDisplay, srsBranchEmployeeInfoErrorsForBannerDisplay },
    srscustomerVerified,
  } = useSelector(({ srs, userData }) => ({
    srsOrgNodeName: userData.initParameters?.srsOrgNodeName,
    srsValidation: srs.srsValidation,
    srsBranchEmployee: srs.srsBranchEmployee,
    srscustomerVerified: srs.srsValidation?.customerVerified,
  }));

  const srsChangeHandler = (fieldId, value) => dispatch(updateSRSBranchEmployeeInfo(fieldId, value));

  const srsErrorChangeHandler = (fieldId, fieldErrorValue, bannerErrorValue) => dispatch(
    updateSRSBranchEmployeeErrorInfo(fieldId, fieldErrorValue, bannerErrorValue),
  );

  const srsSubmitHandler = (event) => {
    event.preventDefault();
    dispatch(validateSRSBranchEmployee());
  };

  if (elementRefInfo != null) {
    if (checkIfMessagesAreUpdated(elementRefInfo, srsBranchEmployeeInfoErrorsForBannerDisplay)) {
      setElementRefInfo((prevState) => {
        const newState = updateMessages(prevState, srsBranchEmployeeInfoErrorsForBannerDisplay);
        return newState;
      });
    }
  }

  return (
    <EVGrid className={classes.container}>
      { srsValidation.isError && srsValidation.srsValidationError != null && (
        <EVAlert
          severity="error"
          className={classes.errorAlertContainer}
          iconMapping={{ success: <EVCheckCircleOutlineIcon /> }}
        >
          <EVTypography className={classes.submitMessage}>{srsValidation.srsValidationError}</EVTypography>
        </EVAlert>
      )}
      {!srsValidation.isLoading
      && Object.values(srsBranchEmployeeInfoErrorsForDisplay).some((val) => val !== '')
      && <ValidationMessageBanner title={t('order__srs_branch_employee__validation_title')} elementRefInfo={elementRefInfo} />}
      <SRSBranchEmployeeForm
        isLoading={srsValidation.isLoading}
        srsOrgNodeName={srsOrgNodeName}
        srsBranchEmployeeInfo={srsBranchEmployeeInfo}
        srsBranchEmployeeInfoErrors={srsBranchEmployeeInfoErrorsForDisplay}
        handleChange={srsChangeHandler}
        handleErrorChange={srsErrorChangeHandler}
        handleSubmit={srsSubmitHandler}
        updateElementRefs={updateElementRefInfo}
        srsInfoVerified={srscustomerVerified}
      />
    </EVGrid>
  );
}

export default SRSBranchEmployeeComponent;
